import React, { Component } from "react";
import Button from "../elements/Button";

class SelectToggle extends Component {
  render() {
    let classes = ["select-toggle"];
    classes = classes.concat(this.props.classes);

    return (
      <div className={classes.join(" ")}>
        {this.props.options.map(option => (
          <Button
            key={option}
            selected={this.props.selected === option}
            onClicked={() => this.props.onValueChange(option)}
          >
            {option}
          </Button>
        ))}
      </div>
    );
  }
}
export default SelectToggle;



// WEBPACK FOOTER //
// ./src/components/SelectToggle.js